import React, { Component } from 'react';
import { LocalVideoTrack } from 'twilio-video'
import ScreenShare from '../../../../_services/Video/Screenshare';

const screenShare = new ScreenShare();

class ShareScreenButton extends Component {
  constructor(props) {
    super(props);

    this.localTrack = null;

    this.state = {
      isScreenSharing: false,
      isDisabled: true
    };
  }

  componentDidMount() {
    screenShare.getVersion()
      .then(() => {
        this.setState({
          isDisabled: false
        })
      });
  }

  handleScreenShare() {
    const screenShareState = !this.state.isScreenSharing;

    if (screenShareState) {
      screenShare.start()
        .then(stream => {
          this.localTrack = new LocalVideoTrack(stream.getVideoTracks()[0]);

          this.localTrack.once('stopped', () => {
            this.setState({
              isScreenSharing: false
            });

            this.props.unpublishScreenCapture(this.localTrack);

            screenShare.showWindow();
          });

          this.setState({
            isScreenSharing: screenShareState
          });

          this.props.publishScreenCapture(this.localTrack);

          screenShare.minimizeWindow();
        });
    } else {
      this.localTrack.stop();
      this.localTrack = null;
    }
  }

  render() {
    const btnClass = this.state.isScreenSharing ? 'teleVideoBtn on' : 'teleVideoBtn';

    const { isDisabled } = this.state;

    if (isDisabled) {
      return (
        <div className="text-center">AxS Chrome Extension is required to screen share. <a target="_blank" rel="noopener noreferrer" href="https://chrome.google.com/webstore/detail/axs-health/kepkbohepfffllfnieocfhgiihcibhod?hl=en">Download Now!</a></div>
      )
    }

    return (
      <button
        onClick={(e) => { e.preventDefault(); this.handleScreenShare(); }}
        type="button"
        className={btnClass}
      >
        <i className="fa fa-desktop"></i>
      </button>
    )
  }
}

export default ShareScreenButton;